import styled from 'styled-components';

/*
  One of these two CSS properties are hijacking the PhotoSwipe modal on iOS devices:
  -webkit-overflow-scrolling: touch;
  overflow-y: auto;
*/

const PageWrapper = styled.div`
  max-width: 100vw;
  min-width: 100vw;
  min-height: 100vh;
  width: 100vw;
`;

const MainBodyWrapper = styled(PageWrapper)`
  -webkit-overflow-scrolling: ${props => (props.overflowScroll ? props.overflowScroll : 'touch')};
  ${props => (props.overflowy ? null : 'overflow-y: auto;')}
  position: absolute;
  top: 80px;
`;

export { MainBodyWrapper, PageWrapper };
